// AWS Amplify Configuration Template - autogenerated at deploy time
/* eslint no-template-curly-in-string: 0*/
const config = {
  s3: {
    REGION: "eu-central-1",
    BUCKET: "app-be-investor-dev-sb-687842713118-uploads",
  },
  apiGateway: {
    REGION: "eu-central-1",
    URL: "https://fxq5zurd5b.execute-api.eu-central-1.amazonaws.com/dev/v1",
  },
  cognito: {
    REGION: "eu-central-1",
    USER_POOL_ID: "eu-central-1_z9021zAoO",
    APP_CLIENT_ID: "1aaqfhmsj9g6e1cqp2ukupgejt",
    IDENTITY_POOL_ID: "eu-central-1:c71f0a7b-eb33-44c5-84ea-848b3a9984b4",
  },
  locales: {
    URL: "https://locales.platform-dev-sb.dev.beteiligungsboerse.net",
  },
  datastore: {
    URL: "https://datastore.platform-dev-sb.dev.beteiligungsboerse.net",
  },
  registration: {
    URL: "https://registration.platform-dev-sb.dev.beteiligungsboerse.net/v1",
    NEXT_PAGE: "https://app.investor-dev-sb.dev.beteiligungsboerse.net",
    TO_REFERRER: "https://www.beteiligungsboerse.eu/register-success/",
  },
  product: {
    PRODUCT_KEY: "investor",
  },
};

export default config;
